import 'css-chunksrc/client/scenes/taskStatuses/styles.scss';export default {
  "main": "_main_10cx3_1",
  "form": "_form_10cx3_7",
  "statuses": "_statuses_10cx3_12",
  "loader": "_loader_10cx3_16",
  "colorPicker": "_colorPicker_10cx3_26"
};